var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"research"}},[_vm._v("请到电脑端填写调查！")])
}
var staticRenderFns = []

export { render, staticRenderFns }